import R from "ramda";
import { http } from "./http";

export const fetchActiveAccount = () => (
  http.get("/internal/storage")
    .then((response) => response.data.activeAccountId)
);

export const fetchFavouriteAccount = () => (
  http.get("/internal/storage")
    .then((response) => response.data.favouriteAccountId)
);

export const fetchDefaultInterface = () => (
  http.get("/internal/storage")
    .then((response) => response.data.isBetaDefault)
);

export const fetchViewedBetaStatus = () => (
  http.get("/internal/storage")
    .then((response) => response.data.hasViewedBeta)
);

export const fetchCustomTabs = () => (
  http.get("/internal/storage")
    .then((response) => response.data.customTabs)
);

const putStorageCreator = (key, value, update) => (
  http.get("internal/storage")
    .then((response) => {
      const storage = response.data;
      const newStorage = update(key, value, storage);
      return http.put("/internal/storage", newStorage);
    })
);

const keyValueStorageUpdate = (key, value, storage) => R.set(R.lensProp(key), value, storage);
const appendValueStorageUpdate = (key, value, storage) => {
  const newArray = R.append(value, R.prop(key, storage));
  return R.set(R.lensProp(key), newArray, storage);
};

export const putActiveAccount = (accountId) => (
  putStorageCreator("activeAccountId", accountId, keyValueStorageUpdate)
);

export const putFavouriteAccount = (accountId) => (
  putStorageCreator("favouriteAccountId", accountId, keyValueStorageUpdate)
);

export const putDefaultInterface = (isBetaDefault) => (
  putStorageCreator("isBetaDefault", isBetaDefault, keyValueStorageUpdate)
);

export const putBetaViewedStatus = (hasViewedBeta) => (
  putStorageCreator("hasViewedBeta", hasViewedBeta, keyValueStorageUpdate)
);

export const putCustomTab = (customTab) => (
  putStorageCreator("customTabs", customTab, appendValueStorageUpdate)
);

export const removeCustomTab = (tabId) => (
  http.get("internal/storage")
    .then((response) => {
      const storage = response.data;
      const customTabs = storage.customTabs;
      const tabIndex = R.findIndex(R.propEq("id", tabId))(customTabs);
      const newCustomTabs = R.remove(tabIndex, 1, customTabs);
      const newStorage = R.set(R.lensProp("customTabs"), newCustomTabs, storage);
      return http.put("/internal/storage", newStorage)
        .then(() => newCustomTabs);
    })
);



// WEBPACK FOOTER //
// ./src/js/api/storage.js